import { Directive, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';

@Directive({ selector: '[clickOutside]', standalone: true })
export class ClickOutsideDirective implements OnInit, OnDestroy {
  @Output() clickOutside = new EventEmitter<void>();
  private listener!: () => void;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    // delay so the opening click doesn't immediately trigger close
    setTimeout(() => {
      this.listener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
        if (!this.el.nativeElement.contains(event.target)) {
          this.clickOutside.emit();
        }
      });
    }, 0);

    setTimeout(() => {
      this.listener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
        console.log('doc click', this.el.nativeElement.contains(event.target)); // 👈
        if (!this.el.nativeElement.contains(event.target)) {
          this.clickOutside.emit();
        }
      });
    }, 0);
  }

  ngOnDestroy() {
    if (this.listener) this.listener(); // cleanup
  }
}
